import React from "react"

type LegacyLayoutProps = {
  children: React.ReactNode
}

export default function LegacyLayout({ children }: LegacyLayoutProps) {
  return <>{children}</>
}

